import { useEffect, useRef, useState } from 'react';

interface ExpandableTextProps {
  text: string;
  className?: string;
}

export function ExpandableText({ text, className }: ExpandableTextProps) {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const ref = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (el === null) return;
    if (!expanded) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [text, expanded]);

  return (
    <div>
      <p
        ref={ref}
        className={`${className ?? ''} ${expanded ? 'wrap-break-word' : 'line-clamp-4'}`}
      >
        {text}
      </p>
      {(isClamped || expanded) && (
        <button
          onClick={() => setExpanded(prev => !prev)}
          className="text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:underline mt-0.5"
        >
          {expanded ? 'Weniger anzeigen' : 'Mehr anzeigen'}
        </button>
      )}
    </div>
  );
}
